export default __webpack_public_path__ + "static/media/close.7974853f.svg";